<template>
  <div class="py-7">
    <v-container>
      <v-row justify="center">
        <v-col
          cols="12"
          md="8"
          lg="7"
          class="mt-4 pr-lg-16"
          order="12"
          order-lg="0"
        >
          <div class="white--text text-center mb-4 contact-title">Casting</div>

          <v-form
            @submit="onSubmit"
            :action="this.server + this.$route.fullPath"
            ref="form"
            enctype="multipart/form-data"
            id="form-casting"
            v-model="valid"
            lazy-validation
          >
            <v-text-field
              dense
              name="name"
              v-model="name"
              :rules="nameRules"
              label="Nome"
              required
              outlined
              dark
            ></v-text-field>

            <v-row>
              <v-col cols="12" md="6" class="pb-0 pb-md-3">
                <v-text-field
                  dense
                  name="email"
                  v-model="email"
                  :rules="emailRules"
                  label="E-mail"
                  required
                  outlined
                  dark
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6" class="pt-0 pt-md-3">
                <v-text-field
                  dense
                  name="phone"
                  v-model="phone"
                  :rules="phoneRules"
                  label="Telefone"
                  required
                  outlined
                  v-mask="'(##) ####-####'"
                  dark
                ></v-text-field>
              </v-col>
            </v-row>

            <v-text-field
              dense
              name="video"
              v-model="video"
              :rules="videoRules"
              label="Link do seu vídeo"
              required
              outlined
              dark
            ></v-text-field>

            <v-file-input
              dense
              prepend-icon="fa-camera-retro"
              clear-icon="fa-times"
              id="file"
              name="photo"
              v-model="photo"
              :rules="photoRules"
              label="Foto de Perfil"
              required
              outlined
              dark
              chips
              truncate-length="25"
            ></v-file-input>

            <v-textarea
              dense
              name="message"
              v-model="message"
              :rules="messageRules"
              label="Mensagem"
              :counter="300"
              required
              outlined
              dark
            ></v-textarea>

            <v-checkbox
              name="policy_privacy"
              v-model="policy_privacy"
              :rules="[(v) => !!v || 'Você precisa aceitar para continuar.']"
              required
              value="1"
              on-icon="fa fa-check-square"
              off-icon="far fa-square"
              class="policy-privacy mt-0"
              dark
            >
              <template v-slot:label>
                <div>
                  Eu li e concordo com a
                  <a
                    @click="showPrivacy"
                    class="secondary--text text--lighten-1"
                    >Política de Privacidade</a
                  >.
                </div>
              </template>
            </v-checkbox>

            <v-btn
              color="secondary"
              class="py-4 px-12 mt-4 font-weight-medium btn-casting"
              type="submit"
              depressed
              height="42"
            >
              ENVIAR
            </v-btn>
          </v-form>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="response" max-width="500px">
      <v-card>
        <v-toolbar dark :color="dialog.color">
          <v-toolbar-title>
            <v-icon> {{ dialog.icon }} </v-icon>
            {{ dialog.title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark icon @click="response = false">
              <v-icon> fa fa-times </v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text class="mt-5">
          {{ dialog.text }}
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import { phoneTest } from "../utils";

export default {
  data: () => ({
    loadingForm: false,
    valid: true,
    name: "",
    nameRules: [(v) => !!v || "Digite seu nome."],
    email: "",
    emailRules: [
      (v) => !!v || "Digite seu e-mail.",
      (v) => /.+@.+\..+/.test(v) || "Digite um e-mail válido.",
    ],
    phone: "",
    phoneRules: [
      (v) => !!v || "Digite seu telefone.",
      (v) => phoneTest(v) || "Digite um telefone válido",
    ],
    video: "",
    videoRules: [
      (v) => !!v || "Cole o link do seu vídeo de qualquer plataforma.",
    ],
    photo: null,
    photoRules: [
      (v) => !!v || "Escolha uma foto para enviar",
      (v) =>
        (v && ["image/jpg", "image/jpeg", "image/png"].includes(v.type)) ||
        "Extensão inválida, tente enviar jpg, jpeg ou png",
    ],
    message: "",
    messageRules: [
      (v) => !!v || "Digite sua mensagem.",
      (v) =>
        v.length <= 300 || "Sua mensagem deve conter menos que 300 caracteres",
    ],
    policy_privacy: false,
    response: false,
    dialog: {
      color: "",
      icon: "",
      title: "",
      text: "",
    },
  }),
  methods: {
    showPrivacy: () => window.showPrivacyPolicy(),
    onSubmit(event) {
      const form = document.getElementById("form-casting");

      if (this.$refs.form.validate()) {
        this.loadingForm = true;

        const formData = new FormData(form);
        const action = `${this.server}/rest/email/casting`;

        fetch(action, {
          method: "POST",
          body: formData,
        })
          .then((r) => {
            if (r.ok) {
              this.$refs.form.reset();
              this.$refs.form.resetValidation();

              this.dialog.color = "primary";
              this.dialog.icon = "fa fa-check-circle";
              this.dialog.title = "Mensagem enviada!!!";
              this.dialog.text =
                "Sua mensagem foi enviada, responderemos em breve.";
            } else {
              this.dialog.color = "warning";
              this.dialog.icon = "fa fa-exclamation-circle";
              this.dialog.title = "OPS!!!";
              this.dialog.text =
                "Sua mensagem não pode ser enviada, verifique as informações e tente novamente.";
            }
          })
          .catch(() => {
            this.dialog.color = "warning";
            this.dialog.icon = "fa fa-exclamation-circle";
            this.dialog.title = "OPS!!!";
            this.dialog.text =
              "Sua mensagem não pode ser enviada, verifique as informações e tente novamente.";
          })
          .finally(() => {
            this.response = true;
          });
      }

      event.preventDefault();
    },
  },
  directives: {
    mask,
  },
};
</script>

<style scoped>
.contact-title {
  font-size: 37px;
  font-weight: 400;
  line-height: 55px;
}

.btn-contact {
  font-size: 16px;
}
</style>
